module.exports = __webpack_public_path__ + "img/f5.d212d423.jpg";